// video.js 本体と全プラグイン（VR・DVR 除く）を import し登録する共有モジュール。
// エントリーポイント（videojs.js / videojs_with_vr.js / videojs_with_dvr.js）からインポートして使う。

import videojs from 'video.js';
import 'video.js/dist/video-js.css';

// プラグイン
import 'videojs-contrib-quality-levels';
import hlsQualitySelector from 'videojs-hls-quality-selector';
import offset from 'videojs-offset';
// seek_buttons_phone.js は videojs-seek-buttons の独自カスタム版で、
// 同名の seekButtons プラグインを単独で登録する（npm 版は不要）
import '@/video_player/seek_buttons_phone';

// 同一ページで複数エントリーポイントが読み込まれた場合の重複登録を防止
if (!videojs.getPlugin('offset')) {
  videojs.registerPlugin('offset', offset);
}
if (!videojs.getPlugin('hlsQualitySelector')) {
  videojs.registerPlugin('hlsQualitySelector', hlsQualitySelector);
}

export default videojs;
